import cx from 'classnames';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {InformationModal, FormControls, Alert, CopyText} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS.OAUTH;

interface ViewSecretModalProps {
    isOpen: boolean;
    secret: string | null;
    onClose: () => void;
}

export const ViewSecretModal: React.FC<ViewSecretModalProps> = ({
    isOpen,
    secret,
    onClose,
}) => {
    const {t} = useTranslation();

    return (
        <InformationModal
            open={isOpen}
            title={t(T_KEYS.SECRET_MODAL.TITLE)}
            maxWidth='lg'
            onClose={onClose}
        >
            <FormControls>
                <Alert type='warning'>
                    {t(T_KEYS.SECRET_MODAL.WARNING)}
                </Alert>

                <div className='tw-mt-8'>
                    <div className='tw-ts-base-bold tw-mb-2'>
                        {t(T_KEYS.SECRET_MODAL.CLIENT_SECRET)}
                    </div>
                    <CopyText
                        text={secret || ''}
                        iconSize='sm'
                        labelPlacement='left'
                        textInTooltip={false}
                        copiedLabelOnly
                        className={cx('tw-bg-light tw-w-full tw-border tw-border-default',
                            'tw-rounded-lg tw-p-3 tw-text-md tw-break-all tw-cursor-pointer')}
                    />
                </div>
            </FormControls>
        </InformationModal>
    );
};